
import { ViewStyle } from 'react-native';
import styled from 'styled-components/native';
import { Label, Text } from '@fkhplus/common/src/components/atoms/Text';

export const Content = styled.View`
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    width: 100%;
    margin-top: 10px;
  `;

export const OTPLabel = styled(Label) <{ hasError: boolean }>`
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  margin-left: 12px;
  margin-bottom: 5px;
  color: ${(props: any) => props.hasError ? props.theme.palette.danger : props.theme.palette.neutral.greys500};;
`;

export const AuthenticationText = styled(Text)`
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  margin-left: 5px;
  color: ${props => props.theme.palette.neutral.greys700};
`;


export const Container = styled.View`
    width: 100%;
    height: auto;
  `;

export const TimerContainer = styled.View<{ style?: ViewStyle }>`
     justify-content: flex-start;
    flex-direction: row;
    align-items: center;
    left: 10px;
    margin-top: 10px;
  ${props => ({ ...props?.style as object })};
  `;

export const OTPInputContainer = styled.View`
    justify-content: space-evenly;
    flex-direction: row;
    width: 80%;
  `;